import { variants, variantsTextField, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
var bgImage = "/assets/img/GradientfromAssurehub.svg";
var logo = "/assets/img/AssurehubLogo.png";
var logoSSO = "/assets/img/MicrosoftLogofromAssurehub.png";
export var loginCT = {
    bgImage: bgImage,
    title: "Inicia Sesión",
    logo: logo,
    sso: {
        logo: logoSSO,
        title: "Ingresar con Microsoft",
    },
    inputEmail: {
        id: "email",
        label: "Correo",
        placeholder: "Ingresa tu correo",
        variant: variantsTextField.outlined,
    },
    inputPassword: {
        id: "password",
        label: "Contraseña",
        variant: variantsTextField.outlined,
    },
    btnLogin: {
        label: "Iniciar sesion",
        variant: variants.outlined,
    },
};
